module.exports = __webpack_public_path__ + "img/5_hsgeoje.c7401c3a.jpg";